import { AuthenticationService } from './service/AuthenticationService';

export const authenticator = new AuthenticationService();
